<form [formGroup]="financingSources" id="financing-sources" (ngSubmit)=onSubmit(financingSources)>
	<div class="d-flex flex-column justify-content-lg-start  justify-content-sm-center  flex-column m-step-wrapper container"
		[ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion"
			(editQuestionChange)="editQuestionChange($event)">
			<question [qID]="'1'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="text-lg-right app-title-xxxlarge-blue">{{"FINANCING_SOURCES.QUESTION1.QUESTION_1"|translate}}<br />
					{{"FINANCING_SOURCES.QUESTION1.QUESTION_2"|translate}}
				</h1>
				<inner-tooltip [qTitle]="'FINANCING_SOURCES.QUESTION1.TOOLTIP_TITLE'|translate"
					[text]="'FINANCING_SOURCES.QUESTION1.TOOLTIP_TEXT'|translate" class="m-start-tooltip app-title-small-blue">
				</inner-tooltip>
				<div>
					<app-incomes-array formArrayName="incomes" (onAddFormGroup)="setValidators()" [needSources]="true"
						(onIncomesChange)="setValidators()" [incomeTypes]="sourceSelect"
						[incomesFormArray]="financingSources.get('incomes')" [displayErrors]="submitted"
						[titles]="['FINANCING_SOURCES.QUESTION1.LABEL1','FINANCING_SOURCES.QUESTION1.LABEL2','FINANCING_SOURCES.QUESTION1.LABEL3']"
						[ph]="['FINANCING_SOURCES.QUESTION1.PH2' | translate]"
						[buttons]="['FINANCING_SOURCES.QUESTION1.BUTTON_ADD','FINANCING_SOURCES.QUESTION1.BUTTON_ADD_AND_SAVE']">
					</app-incomes-array>
				</div>
				<br />
				<div class="d-flex justify-content-md-end justify-content-center">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': financingSources.valid && qID=='1', 'button-primary-disabled': !financingSources.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				</div>
			</question>
			<question [qID]="'5'">
				<div class="mx-4 mt-md-0 mt-5">
				<div>
					<h1 class="text-lg-right app-title-xxxlarge-blue">{{"FINANCING_SOURCES.QUESTION2.QUESTION"|translate}}</h1>
					<img src="assets/images/icons/calculator.svg" aria-hidden="true">
					<span>{{"FINANCING_SOURCES.QUESTION2.CALCULATOR_TEXT1"|translate}}</span>
					<a href="https://www.mizrahi-tefahot.co.il/mortgages/calculator" target="_blank"
						class="link">{{"FINANCING_SOURCES.QUESTION2.CALCULATOR_TEXT2"|translate}}</a>
					<span>{{"FINANCING_SOURCES.QUESTION2.CALCULATOR_TEXT3"|translate}}</span>

				</div>
				<div class="row mt-4">
					<div class="col-12 col-md-4 col-lg-4 "> 
					<div class="input-wrapper">
						<app-animated-input formControlName="mortgageMonthlyRefund" [type]="'text'" placeholder="{{'LIABILITIES.QUESTION5.LIABILITY_BALANCE'|translate}}" attAriaLabel="{{'LIABILITIES.QUESTION1.REQUIRED1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true"></app-animated-input>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="financingSources.get('mortgageMonthlyRefund').hasError('required') && submitted">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="financingSources.get('mortgageMonthlyRefund').hasError('amountValidator') && submitted">{{ 'FINANCING_SOURCES.QUESTION2.ERROR_AMONT_VALIDATOR' | translate }}</label>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="warnInfo && submitted">{{ 'FINANCING_SOURCES.QUESTION2.INFO_AMONT_VALIDATOR' | translate }}</label>
					</div>
				</div>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': financingSources.valid && qID=='5', 'button-primary-disabled': !financingSources.valid}">{{"COMMON.PROCEED"|translate}}</button>

				</div>
			</div>

			</question>
		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/financing-sources/financing-sources.component.html